var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunLine = function SvgSunLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 14.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6M9.25 1.75h1.5V4h-1.5zm0 14.25h1.5v2.25h-1.5zM3.636 4.697l1.06-1.06 1.592 1.59-1.061 1.06zm10.077 10.076 1.06-1.06 1.59 1.59-1.06 1.06zm1.59-11.137 1.06 1.06-1.59 1.592-1.06-1.061zM5.227 13.713l1.06 1.06-1.59 1.59-1.06-1.06zM18.25 9.25v1.5H16v-1.5zM4 9.25v1.5H1.75v-1.5z"
  })));
};
export default SvgSunLine;